import React from 'react'
import { graphql } from '@apollo/client/react/hoc'
import AppointmentQuery from '../../../graphql/Appointment.graphql'
import ServicesQuery from '../../../graphql/ServicesQuery.graphql'
import CreateAppointmentMutation from '../../../graphql/CreateAppointmentMutation.graphql'
import ListStaffMembersForStoreQuery from '../../../graphql/ListStaffMembersForStoreQuery.graphql'
import SearchOpenAuthStoresByAddressQuery from '../../../graphql/SearchOpenAuthStoresByAddressQuery.graphql'
import StoreWithDistanceQuery from '../../../graphql/StoreWithDistanceQuery.graphql'
import settings from '../../components/settings'
import { useSearchAddress } from '../../hooks/location/useSearchAddress'
import { useRetrieveAddress } from '../../hooks/location/useRetrieveAddress'
import { queryFake } from '../../../utils/initValues'

const fetchStores = graphql(SearchOpenAuthStoresByAddressQuery, {
  name: 'storesByAddressData',
  options: ({ selectedAddress }) => ({
    variables: {
      input: {
        includeFakes: !!queryFake, // always use true
        city: selectedAddress.city,
        countryName: selectedAddress.countryName,
        line1: selectedAddress.line1,
        line2: selectedAddress.line2,
        line3: selectedAddress.line3,
        postalCode: selectedAddress.postalCode,
        latitude: selectedAddress.latitude,
        longitude: selectedAddress.longitude,
      },
    },
    fetchPolicy: 'no-cache',
  }),
  skip: ({ selectedAddress }) => !selectedAddress,
})

const fetchStaffMembers = graphql(ListStaffMembersForStoreQuery, {
  name: 'listStaffMembersForStoreData',
  options: ({ selectedStore }) => ({
    variables: {
      storeId: selectedStore.id,
    },
  }),
})

const fetchStoreWithDistance = graphql(StoreWithDistanceQuery, {
  name: 'StoreWithDistance',
  options: ({ storeId, selectedAddress }) => {
    // eslint-disable-next-line camelcase
    const { id, label, __typename, ...input } = selectedAddress || {}
    return {
      variables: {
        storeId,
        input,
      },
      fetchPolicy: 'no-cache',
    }
  },
  skip: ({ storeId, selectedAddress }) =>
    storeId === null || selectedAddress === null,
})

const searchAddressQuery = (Wrapped) => {
  const Comp = ({ selectedAddress, ...rest }) => {
    const { data: addresses } = useSearchAddress(
      {
        searchText: '',
        refinementId: settings.addressPrefix,
        limit: 1,
      },
      !selectedAddress
    )
    const { data: address } = useRetrieveAddress(
      addresses ? addresses[0]?.id : undefined,
      !!(addresses && addresses.length)
    )

    return (
      <Wrapped
        {...rest}
        selectedAddress={selectedAddress}
        retrieveAddress={address}
      />
    )
  }

  Comp.displayName = "SearchAddressComponent"

  return Comp
}

const createBooking = graphql(CreateAppointmentMutation)

const getBooking = graphql(AppointmentQuery, {
  name: 'appointment',
  options: ({ appointmentId }) => ({
    variables: {
      id: appointmentId,
    },
  }),
  skip: ({ appointmentId }) => !appointmentId,
})

const fetchServices = graphql(ServicesQuery, {
  name: 'services',
  options: ({ selectedStore }) => ({
    variables: {
      subsystem: selectedStore.simplyBookMeSubsystem,
    },
  }),
})

export {
  fetchStoreWithDistance,
  fetchStores,
  fetchStaffMembers,
  fetchServices,
  createBooking,
  getBooking,
  searchAddressQuery,
}
